import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useTheme = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: 0,
      marginTop: -theme.spacing(2),
    },

    iconContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#F7F8FB',
      width: 200,
      height: 200,
      borderRadius: 100,
      marginTop: theme.spacing(6) - 3,
      marginBottom: theme.spacing(6),
    },
    icon: {
      fontSize: 130,
    },
    button: {
      minWidth: 100,
      textTransform: 'none',
      background: '#0094FF',
      borderRadius: 10,
      color: theme.palette.colors.white,
      '&:hover': {
        background: '#0094FF',
        filter: 'brightness(0.9)',
      },
    },
    cancelButton: {
      textTransform: 'none',
      borderRadius: 10,
      marginRight: 8,
      background: 'transparent',
      color: '#14171A',
    },
  }),
);

export default useTheme;
